import type { ReactNode } from "react";
import { CertificationSectionHeader } from "@modules/certificaciones/shared/ui";

type Props = {
  eyebrow: string;
  title: string;
  description: string;
  onBack: () => void;
  onRefresh?: () => void;
  refreshing?: boolean;
  actions?: ReactNode;
};

export function Iso900114001SectionHeader(props: Props) {
  return <CertificationSectionHeader {...props} standardLabel="ISO 9001-14001" />;
}
